export default {
  placesAndDirections: {
    isochrones: 'Isochronen',
    place: 'Ort',
    notRouteFound: 'Keine Route mit diesem Fahrzeugprofil für die gewählten Orte gefunden.',
    notRouteFoundWithFilters: 'Keine Route mit diesem Profil für die gewählten Einstellungen und Orte gefunden.',
    noPlaceFound: 'Keinen Ort mit diesen Angaben gefunden',
    routeReady: 'Route bereit',
    useLocation: 'Meinen Standort nutzen',
    addPlaceInput: 'Ort hinzufügen',
    clearRoute: 'Route löschen',
    reverseRoute: 'Route umkehren',
    orderByClosestPlaces: 'Nach Entfernung anordnen',
    calculatingRoute: 'Route wird berechnet…',
    yourLocation: 'Mein Standort',
    expandAltitudeChart: 'Höhenprofil vergrößern',
    errorRenderingContentUploaded: 'Fehler beim Anzeigen des hochgeladenen Objekts. Überprüfen Sie das Dateiformat und den Inhalt.',
    roundTrip: 'Rundweg',
    notPossibleToCalculateRoute: 'Keine Route zwischen den gewählten Orten gefunden.',
    apiError: {
      2000: 'Umwandlung der JSON-Anfrage nicht möglich.',
      2001: 'Erforderlicher Parameter fehlt',
      2002: 'Ungültiges Parameterformat',
      2003: 'Die Routenparameter überschreiten einen oder mehrere Grenzwerte. Bitte denken Sie an die Grenzwerte bei Vermeidungs-Parametrn (z.B. max. 20.000 Quadratkilometer für zu vermeidende Polygone)',
      2004: 'Die Routenparameter überschreiten einen oder mehrere Grenzwerte. Denken Sie daran, dass die ungefähre Streckenlänge nicht mehr als 6000 km betragen darf. Wenn bestimmte Routenoptionen oder vermeidbare Routen verwendet werden, darf die ungefähre Routenentfernung nicht mehr als 150 km betragen.',
      2006: 'Die Anfrage an den Export-Handler konnte nicht verarbeitet werden',
      2007: 'Export-Format nicht unterstützt',
      2008: 'Leeres Element',
      2009: 'Es konnte keine geeignete Route mit den angegebenen Orten und Parametern gefunden werden. Möglicherweise wird das angegebene Profil in diesem Bereich / dieser Region mit den angewendeten Filtern nicht unterstützt.',
      2010: 'Mindestens ein Wegpunkt wurde nicht gefunden. Möglicherweise kann einer der gewählten Punkte nicht genutzt werden oder das ausgewählte Profil wird in dieser Region nicht unterstützt..',
      2011: 'Alternative Routen unterstützen keine Wegpunkte.',
      2012: 'Es wurde ein ungültiger Parameter angegeben. Bitte stellen Sie sicher, dass die URL korrekt ist.',
      2099: 'Es konnte keine Route gefunden werden, die die ausgewählten Orte verbindet.'
    },
    genericErrorMsg: 'Keine Route gefunden',
    reorder: 'Neu ordnen',
    timeoutError: 'Die Anfrage dauerte zu lange und wurde abgebrochen. Versuchen Sie kürzere Distanzen.',
    timeBasedRouteHeader: 'Zeitpunkt auswählen',
    citySelection: 'Stadt auswählen',
    planRoute: 'Route planen',
  }
}
